<template>
  <div class="wxck-auto-login">
    <div class="login-container">
      <div class="login-content">
        <!-- 加载状态 -->
        <div v-if="status === 'loading'" class="status-loading">
          <div class="spinner"></div>
          <div class="loading-text">自动登录中...</div>
          <div class="login-info">用户: {{ loginData.username }}</div>
        </div>
        
        <!-- 成功状态 -->
        <div v-if="status === 'success'" class="status-success">
          <div class="success-icon">✓</div>
          <div class="success-text">登录成功！</div>
          <div class="redirect-text">正在跳转...</div>
        </div>
        
        <!-- 错误状态 -->
        <div v-if="status === 'error'" class="status-error">
          <div class="error-icon">✗</div>
          <div class="error-text">自动登录失败</div>
          <div class="error-message">{{ errorMessage }}</div>
          <div class="retry-section">
            <button @click="retryLogin" class="retry-btn">重试登录</button>
            <button @click="goToManualLogin" class="manual-btn">前往手动登录</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { dologin } from '@/api/login'

export default {
  name: 'WxckAutoLogin',
  data() {
    return {
      status: 'loading',
      loginData: {
        username: 'wxck',
        password: '123456'
      },
      errorMessage: '',
      retryCount: 0,
      maxRetries: 3
    }
  },
  mounted() {
    console.log('wxck自动登录页面加载完成');
    this.startAutoLogin();
  },
  methods: {
    async startAutoLogin() {
      try {
        // 检查URL参数
        this.checkUrlParams();
        
        console.log('开始自动登录，用户:', this.loginData.username);
        
        // 执行登录
        const response = await dologin(this.loginData);
        console.log("登录结果：",response);
        if (response.result === '0') {
          // 登录成功
          await this.handleLoginSuccess(response);
        } else {
          throw new Error(response.message || '登录失败');
        }
        
      } catch (error) {
        this.handleLoginError(error);
      }
    },
    
    checkUrlParams() {
      const query = this.$route.query;
      
      // 从URL参数获取用户名密码
      if (query.username) {
        this.loginData.username = query.username;
      }
      if (query.password) {
        this.loginData.password = query.password;
      }
    },
    
    async handleLoginSuccess(response) {
	  // 强制确保用户名正确存储
	  const usernameToStore = this.loginData.username || 'wxck';
	  // 先清理再存储，避免缓存问题
	  localStorage.removeItem('username');
	  localStorage.removeItem('token');
      // 使用同步方式存储
      localStorage.setItem('username', usernameToStore);
      localStorage.setItem('token', response.authorization || '');
      localStorage.setItem('entityid', response.entityId || '');
	  
	    // 立即验证存储
	    const storedUsername = localStorage.getItem('username');
	    const storedToken = localStorage.getItem('token');
	    console.log('存储验证 - 用户名:', storedUsername, 'token:', storedToken);
		
		 // 如果用户名存储失败，手动设置
		  if (!storedUsername || storedUsername === 'null') {
		    console.error('用户名存储失败，手动设置');
		    localStorage.setItem('username', this.loginData.username);
		  }
      
      if (response.logoTitle) localStorage.setItem('logoTitle', response.logoTitle);
      if (response.logoMenu) localStorage.setItem('logoMenu', response.logoMenu);
      if (response.logo) localStorage.setItem('logo', response.logo);
      
      console.log('登录成功，准备跳转');
      this.status = 'success';
      
      // 延迟跳转
      setTimeout(() => {
        this.redirectToTarget();
      }, 2000);
    },
    
    handleLoginError(error) {
      console.error('自动登录失败:', error);
      this.status = 'error';
      this.errorMessage = error.message || '网络错误，请检查连接';
      
      this.retryCount++;
      
      // 自动重试
      if (this.retryCount < this.maxRetries) {
        setTimeout(() => {
          this.retryLogin();
        }, 3000);
      }
    },
    
    redirectToTarget() {
      // 确保认证数据正确存储
        const storedUsername = localStorage.getItem('username');
        const storedToken = localStorage.getItem('token');
        
        console.log('跳转前验证 - 用户名:', storedUsername, 'token:', storedToken);
        
        if (!storedUsername || storedUsername === 'null') {
          console.error('用户名存储失败，重新设置');
          localStorage.setItem('username', this.loginData.username || 'wxck');
        }
        
        const redirect = this.$route.query.redirect || '/index';
        console.log('准备跳转到:', redirect);
        
        // 使用replace方法，避免历史记录问题
        try {
          this.$router.replace(redirect).then(() => {
            console.log('跳转成功完成');
          }).catch(error => {
            console.error('跳转失败:', error);
            // 如果路由跳转失败，尝试直接修改location
            window.location.hash = `#${redirect}`;
          });
        } catch (error) {
          console.error('跳转异常:', error);
          // 备用方案：直接修改location
          window.location.href = redirect;
        }

    },
    
    retryLogin() {
      this.status = 'loading';
      this.errorMessage = '';
      this.startAutoLogin();
    },
    
    goToManualLogin() {
      // 跳转到手动登录页面
      this.$router.replace({
        name: 'login',
        query: this.$route.query
      });
    }
  }
}
</script>

<style scoped>
.wxck-auto-login {
  height: 100vh;
  background: linear-gradient(135deg, #2d3a4b 0%, #1a2330 100%);
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-container {
  background: white;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  text-align: center;
  min-width: 350px;
}

.status-loading .spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #409EFF;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}

.loading-text {
  font-size: 18px;
  color: #333;
  margin-bottom: 10px;
}

.login-info {
  color: #666;
  font-size: 14px;
}

.status-success .success-icon {
  font-size: 48px;
  color: #67C23A;
  margin-bottom: 15px;
}

.success-text {
  font-size: 20px;
  color: #333;
  margin-bottom: 10px;
}

.redirect-text {
  color: #409EFF;
  font-size: 14px;
}

.status-error .error-icon {
  font-size: 48px;
  color: #F56C6C;
  margin-bottom: 15px;
}

.error-text {
  font-size: 20px;
  color: #333;
  margin-bottom: 10px;
}

.error-message {
  color: #F56C6C;
  margin-bottom: 20px;
  font-size: 14px;
}

.retry-section {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.retry-btn, .manual-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.retry-btn {
  background: #409EFF;
  color: white;
}

.manual-btn {
  background: #f4f4f5;
  color: #606266;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>